var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightRifle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M59.9998 13.1595L68.8978 11.9265C68.8978 11.9265 70.8688 12.2085 71.3758 12.2085H75.9733L74.3608 14.517L72.2203 14.433L71.3188 15.306H67.4893L63.7168 16.6005L62.8438 15.9525L61.9153 15.981L59.5498 14.9115L59.9998 13.1595V13.1595Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.735 27.7365L110.821 31.4535C110.821 31.4535 111.835 32.172 110.821 33.6075C109.807 35.043 107.527 38.337 107.527 38.337",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.045 24.249V26.6385",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6514 22.542H113.06",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.228 23.5259H92.3647C92.3647 23.5259 89.4922 23.4089 89.4922 25.7624C89.4922 28.1159 93.6172 27.7349 93.6172 27.7349L94.6447 26.4674H99.0787L100.135 27.1574H102.458L103.64 26.1299H113.57",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5416 17.9384L73.2756 19.7954H82.8201L81.7221 18.8669H77.7096L76.6116 17.9384",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5654 17.1765C85.5234 17.43 86.9589 18.6135 86.9589 18.6135H98.8509",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3232 14.9384L61.9982 14.2589L68.0807 13.6724L69.2267 11.9609",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0811 13.6725L75.9711 12.864",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7764 29.1583H81.5964V25.6108H61.3239H57.7764V29.1583Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3232 29.1253V25.6108",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2756 25.7639V29.1254",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9775 25.6108V28.9888",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7757 25.6108L55.1567 25.7638L52.6232 26.2993H42.9932V28.1998H56.0432L57.7757 29.1583",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0439 28.1999V25.7639",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3232 27.3674H73.2752",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9941 26.2996H34.3781L31.6751 26.8066H17.2031V28.2001H32.9141H42.9941",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9922 30.5878L38.6012 28.2568",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7969 26.2409V25.1819H45.0769L55.3819 23.5259L66.5314 23.4134V21.1394",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3005 32.6204V34.9019",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66113 25.7639H11.9661C11.9661 25.7639 14.0496 28.3139 13.8801 28.2569C13.7106 28.1999 2.45763 28.2569 2.45763 28.2569",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M10.367 27.2505C10.4995 27.2505 10.607 27.1431 10.607 27.0105C10.607 26.878 10.4995 26.7705 10.367 26.7705C10.2344 26.7705 10.127 26.878 10.127 27.0105C10.127 27.1431 10.2344 27.2505 10.367 27.2505Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1289 20.9368L11.9094 22.4008L23.2854 21.6688L25.1934 19.9753",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6014 23.6895L36.7969 23.8365",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1555 25.1594H84.833V26.2994H88.1555V25.1594Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M115.564 29.676V31.7475L112.144 37.4355L110.736 38.337H102.852L102.345 37.605H94.1187C93.8007 37.605 93.5006 37.4625 93.2996 37.2165L89.6742 32.763L86.0696 32.706C86.0696 32.706 85.0556 32.706 85.5626 33.6075C86.0696 34.509 87.0836 35.184 87.0836 35.184L86.2946 36.3105L84.9762 37.278C84.7362 37.4535 84.4421 37.5375 84.1466 37.5135L49.4112 34.7895L46.5957 33.7755L30.5757 32.7195L20.9037 32.706C20.6007 32.706 20.3547 32.46 20.3547 32.157C20.3547 31.854 20.6007 31.608 20.9037 31.608H23.0577V30.735H10.1082L7.51766 30.228L3.95666 29.301C3.61466 29.2125 3.34316 28.953 3.23666 28.6155L3.12416 28.257L2.22566 27.9885C1.89116 27.888 1.66016 27.5805 1.66016 27.231V25.992C1.66016 25.6575 1.85966 25.3575 2.16866 25.227L3.35066 24.7305L3.80066 23.1015C3.90116 22.74 4.22966 22.488 4.60616 22.488H5.23766L5.86016 21.537C6.02816 21.2805 6.30116 21.114 6.60416 21.0795L17.4747 19.884C17.7567 19.8525 18.0432 19.9005 18.3012 20.019L19.3002 20.484L26.4402 19.866C26.6577 19.8465 26.8752 19.899 27.0612 20.0145L27.8277 20.493C28.1307 20.682 28.4877 20.7675 28.8447 20.7375L56.7417 18.3315C56.7837 18.3285 56.8256 18.3255 56.8661 18.3255H58.6857C58.7727 18.3255 58.8597 18.3165 58.9452 18.3L61.3917 17.808C61.6602 17.754 61.9377 17.7765 62.1927 17.871L62.8616 18.1185C63.1586 18.228 63.4842 18.228 63.7797 18.1185L68.8962 16.206L76.3856 15.981L77.8497 16.8825H79.2582L79.7126 16.3635C79.9256 16.1205 80.2316 15.981 80.5556 15.981H83.6472C83.9442 15.981 84.2337 16.0695 84.4782 16.236L85.8477 17.163L97.0211 17.055C97.3286 17.052 97.6272 17.1645 97.8567 17.37C98.2857 17.754 98.9666 18.3465 99.0806 18.3465C99.2501 18.3465 102.009 19.2345 102.009 19.2345H107.133L107.527 19.7535L108.372 19.641L109.666 19.2345L110.398 18.459L112.099 18.417C112.446 18.408 112.774 18.567 112.983 18.843L116.355 23.292C116.581 23.592 116.704 23.9565 116.704 24.3315V25.4415L117.03 25.7415C117.289 25.9815 117.436 26.3175 117.436 26.6715V29.985C117.436 30.2775 117.291 30.5505 117.046 30.7125C116.79 30.8835 116.446 30.8265 116.259 30.582L115.563 29.676L113.607 27.1305L113.437 22.6815L110.055 18.819",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4834 24.2491L38.7139 22.2885L41.0224 23.4151C41.0224 23.4151 64.7299 21.2191 64.8994 21.1621C65.0689 21.1051 68.2219 21.1621 68.2219 21.1621L72.9514 17.7841L85.8469 17.1646",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2207 21.162L71.9932 23.5275H78.9757C78.9757 23.5275 83.3122 20.589 83.5927 20.7075C83.8732 20.826 86.3527 20.7045 86.3527 20.7045L87.3097 20.037H93.6727L94.5742 20.7075H97.0522L99.0787 18.348",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7607 32.3954V30.5369L56.9302 31.2419L58.7887 32.1704H71.9662L73.7407 30.8189H79.3147L85.5652 33.6059",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0572 31.0724L85.5652 31.0709L84.3262 29.3804L85.2832 28.5944H89.0572V31.0724Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M101.143 30.735L99.9821 28.5945H94.6886L93.6191 31.5225L96.3776 36.0285H102.121L103.192 34.5075",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M103.193 34.5074H105.164L106.796 32.9534V30.7349H101.144",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5488 13.4324V14.9114L60.6183 15.4184H61.7448L62.1948 15.9809H63.7158C63.7158 16.2839 64.0143 16.4984 64.3023 16.3994L67.4898 15.3059H71.3193L72.1638 14.5169H74.3598L75.9843 12.8519C76.2183 12.6119 76.0488 12.2084 75.7128 12.2084H71.3748C71.3748 12.2084 70.0233 12.0389 68.8968 11.9264C67.9473 11.8319 61.9458 12.5774 60.0933 12.8144C59.7828 12.8534 59.5488 13.1189 59.5488 13.4324Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2752 25.7295H61.3232V28.989H73.2752V25.7295Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2031 28.2569H56.0441V25.7114L52.4966 26.3429H34.5056L31.4636 26.8484H17.2031V28.2569Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M116.707 25.4414V23.7524L112.652 18.4034L110.399 18.4604L108.373 19.6424L107.134 19.2359H102.01C101.56 19.2359 99.0817 18.3479 99.0817 18.3479L97.5052 17.0534L86.4967 17.1599L85.0177 16.6034L83.6527 15.9839H80.4997L79.2607 16.8854H77.8522L76.3882 15.9839L68.8987 16.2089L63.3232 18.2924L61.3237 17.3909L58.8172 18.3284H57.7747L28.2952 20.7884L26.7742 19.8404L19.2982 20.4884L17.9047 19.8404L6.1207 21.1349L5.2912 22.4024L3.9667 22.4909C3.9667 22.4909 3.4807 24.2519 3.4807 24.7334C3.4807 25.2149 1.6582 25.7669 1.6582 25.7669V27.8249L3.1222 28.2614L3.4042 29.1629L10.1047 30.7394L17.6587 30.5924H23.2252L23.3092 31.4159L20.6902 31.5854L20.3527 32.7119L30.0952 32.7254L46.3807 33.7679L49.4092 34.7954L84.6037 37.5554L86.2927 36.3164L87.0817 35.1899L85.5607 33.6134L85.8427 32.7419L87.7567 32.4809L89.9002 33.0509L91.5577 34.5149L93.6127 37.6124H101.527L102.847 38.3444H110.624L112.138 37.4429L115.558 31.7549V30.3194L116.587 31.0229L117.431 30.0074V26.6459L116.699 25.4489L116.707 25.4414ZM56.0452 28.2569H17.2027V26.8484H31.4632L34.5037 26.3414H52.4947L56.0422 25.7099V28.2554L56.0452 28.2569ZM106.796 32.9534L105.163 34.5074H103.192L102.122 36.0284H96.3787L93.6187 31.5239L94.6882 28.5959H99.9817L101.143 30.7364H106.795V32.9549L106.796 32.9534Z",
    fill: "#FAFAFB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7606 30.5369L23.0586 30.7349",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightRifle);
export default __webpack_public_path__ + "static/media/Light Rifle.38ffdc8c4e2e89de4f3b0409ff13b32f.svg";
export { ForwardRef as ReactComponent };